import {
  ClientUser,
  ClientUserInvitation,
  FullEmailVerification,
  FullUserInvitation,
  ServerPasswordReset,
} from './types';
import { StandardMessage, StreamDescription } from '../shared';

export const SUBJECT_BANZAI_INVITATION_CREATE = 'banzai.invitation.create';

export const CreateUserInvitationStream: StreamDescription<StandardMessage<ClientUserInvitation>> =
  {
    name: 'banzai_invitation_create',
    subject: SUBJECT_BANZAI_INVITATION_CREATE,
  };

export const SUBJECT_BANZAI_EMAILVERIFICATION_CREATE = 'banzai.email-verification.create';

export const CreateEmailVerificationStream: StreamDescription<
  StandardMessage<FullEmailVerification>
> = {
  name: 'banzai_email-verification_create',
  subject: SUBJECT_BANZAI_EMAILVERIFICATION_CREATE,
};

export const SUBJECT_BANZAI_PASSWORDRESET_CREATE = 'banzai.password-reset.create';

export const CreatePasswordResetStream: StreamDescription<StandardMessage<ServerPasswordReset>> = {
  name: 'banzai_password-reset_create',
  subject: SUBJECT_BANZAI_PASSWORDRESET_CREATE,
};

export const SUBJECT_BANZAI_USER_CREATE = 'banzai.user.create';

export const CreateUserStream: StreamDescription<StandardMessage<ClientUser>> = {
  name: 'banzai_user_create',
  subject: SUBJECT_BANZAI_USER_CREATE,
};

export const SUBJECT_BANZAI_INVITATION_ACCEPT = 'banzai.invitation.accept';

export const AcceptInvitationStream: StreamDescription<StandardMessage<FullUserInvitation>> = {
  name: 'banzai_invitation_accept',
  subject: SUBJECT_BANZAI_INVITATION_ACCEPT,
};
